import {
  cryptoWallet,
  getReferralCryptoWallet
} from '../../../utilities/selectors';
import { createSelector } from 'reselect';

export const getCurrency = (state, props) =>
  state.global.currencies[props.data.currency];

export const makeGetCryptoWallet = () =>
  createSelector(getCurrency, getReferralCryptoWallet, cryptoWallet);
